import React from 'react';
import { useParams } from 'react-router-dom';
import { isCategorySlug, getSymbolFromSlug } from '../config/categoryMapping';
import InsightsPage from './InsightsPage';
import InsightDetailPage from './InsightDetailPage';

function InsightOrCategoryPage() {
  const { slug } = useParams();

  // Check if the slug matches a known category
  if (slug && isCategorySlug(slug)) {
    const symbol = getSymbolFromSlug(slug);
    return <InsightsPage initialCategory={symbol} categorySlug={slug} />;
  }

  // Otherwise render the article detail page
  return <InsightDetailPage />;
}

export default InsightOrCategoryPage;
